// SEQ=10124 P8-CK-H — Deserter UX 오버레이
// 사양: SEQ-10119 §3-3 #2 + SEQ-10123 §1-2 #2
//   ── (a) 상대 기사 클릭 → target_knight_id 확정
//      (b) 본인 도로 인접 + 빈 vertex 클릭 → target_vertex_id 확정
//   ── 두 단계 진행 상태를 본 오버레이가 추적 + 확정 시 Play.tsx 콜백
//
// 보드 클릭 자체는 Play.tsx handleVertexClick + handleKnightClick(가칭)가 ActionMode 분기로 dispatch.
// 본 오버레이는 화면 상단 안내 배지 + 진행 단계 표시 + 취소 버튼만 담당.
import { CatanKnight, CatanPlayer } from '../../store/catan'

export interface DeserterPlacementOverlayProps {
  /** 현재 단계 (Play.tsx state 와 동기) */
  step:   'pick_knight' | 'pick_vertex'
  /** 선택된 상대 기사 (단계 2에서) */
  pickedKnight?: CatanKnight | null
  /** 후보 vertex 미리보기 (본인 도로 인접 + 빈 vertex 집합) — 보드 highlight 와 동기 */
  candidateVertexIds: number[]
  /** 매치 전 플레이어 정보 (닉네임 lookup) */
  players: CatanPlayer[]
  /** 취소 → ActionMode rollback */
  onCancel: () => void
}

export default function DeserterPlacementOverlay({
  step, pickedKnight, candidateVertexIds, players, onCancel,
}: DeserterPlacementOverlayProps) {
  const pickedNick = pickedKnight
    ? (players.find(p => p.userCode === pickedKnight.userCode)?.nickname ?? `유저 ${pickedKnight.userCode}`)
    : null

  return (
    <div style={overlay}>
      <div style={card}>
        <div style={title}>🥷 탈주병 (Deserter)</div>
        {step === 'pick_knight' ? (
          <div style={body}>
            <div>① 제거할 <b>상대의 기사</b>를 보드에서 클릭하세요.</div>
            <div style={hint}>본인 기사는 선택할 수 없습니다.</div>
          </div>
        ) : (
          <div style={body}>
            <div>① 기사 선택: <b>{pickedNick}</b> (knight #{pickedKnight?.knightId})</div>
            <div>② 신설할 <b>본인 도로 인접 빈 vertex</b>를 클릭하세요.</div>
            <div style={hint}>후보 vertex {candidateVertexIds.length}개 (보드 highlight).</div>
          </div>
        )}
        <div style={footer}>
          <button onClick={onCancel} style={btnSec}>취소</button>
        </div>
      </div>
    </div>
  )
}

// ── 스타일 — 우상단 floating ─────────────────────────────
const overlay: React.CSSProperties = {
  position: 'fixed', top: 12, right: 12, zIndex: 950,
  pointerEvents: 'none',
}
const card: React.CSSProperties = {
  background: '#fff', border: '1px solid #888', borderRadius: 6,
  padding: 12, minWidth: 240, boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
  pointerEvents: 'auto',
}
const title:  React.CSSProperties = { fontWeight: 'bold', marginBottom: 6, fontSize: 14 }
const body:   React.CSSProperties = { fontSize: 12 }
const hint:   React.CSSProperties = { fontSize: 11, color: '#666', marginTop: 4 }
const footer: React.CSSProperties = { marginTop: 8, textAlign: 'right' }
const btnSec: React.CSSProperties = { padding: '4px 10px', background: '#eee', border: '1px solid #aaa', borderRadius: 3, cursor: 'pointer' }
